import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    //
    this.VARS = {}
    this.VARS.IN_VIEW_CLASS = 'is-inview'

    this.createTimeline();
    this.listener()

  }


  createTimeline()
  {
    this.from = JSON.parse(this.DOM.view.getAttribute('data-from'));
    this.to = JSON.parse(this.DOM.view.getAttribute('data-to'));

    if(this.hasCondition && this.condition) {
        this.from = JSON.parse(this.DOM.view.getAttribute('data-from-condition'));
        this.to = JSON.parse(this.DOM.view.getAttribute('data-to-condition'));
    }

    this.tl = new gsap.timeline();
    this.tl.pause();
    this.tl.fromTo(this.DOM.view,{
        ...this.from
    }, {
        ...this.to,
        ease: 'none',
        duration: 1
    });
  }

  listener()
  {
    let hasMarkers = typeof this.DOM.view.getAttribute('data-marker') == 'string';
    let $target = typeof this.DOM.view.getAttribute('data-target') == 'string' ? document.querySelector(this.DOM.view.getAttribute('data-target')) : this.DOM.view

    let options = {
        trigger: $target,
        start: typeof this.DOM.view.getAttribute('data-start') == 'string' ? this.DOM.view.getAttribute('data-start') : 'top bottom',
        end: typeof this.DOM.view.getAttribute('data-end') == 'string' ? this.DOM.view.getAttribute('data-end') : 'bottom top',
        markers: hasMarkers,
        onEnter: () => {
            this.onElementEnter('down')
        },
        onLeave: () => {
            this.onElementLeave('down',this.DOM.view.getAttribute('data-call-leave'))
        },
        onEnterBack: () => {
            this.onElementEnter('up')
        },
        onLeaveBack: () => {
            this.onElementLeave('up')
        }
    }
    options = {...options,
      onUpdate: (self) => {
        this.progress(self);
      }
    }
    this.sTrigger = ScrollTrigger.create(options);
  }

  onElementEnter()
  {
    this.DOM.view.classList.add(this.VARS.IN_VIEW_CLASS);
  }

  onElementLeave(direction,fn)
  {
    this.DOM.view.classList.remove(this.VARS.IN_VIEW_CLASS);
    // if(typeof fn != 'undefined' && typeof fn == 'string') {
    //   // console.log(fn);
    //   var fn = new Function(fn);
    //   fn();
    //   // window[fn]()
    // }
  }

  progress({progress, isReversed}) {
    let relativeProgress = progress;
    if(isReversed) relativeProgress = 1-progress;

    if(this.tl != undefined) {
        this.tl.progress(relativeProgress);
    }
  }

  unmount()
  {
    this.sTrigger.kill(true)
  }
}
